import { Component, OnInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-meu-faturamento',
  templateUrl: './meu-faturamento.component.html',
  styleUrls: ['./meu-faturamento.component.scss']
})
export class MeuFaturamentoComponent implements OnInit {
  public contaId: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.obterIdClienteId();
  }

  obterIdClienteId() {
    this.contaId = this.route.snapshot.params['contaId'];
  }
}
